module.exports = __webpack_public_path__ + "img/awards_image_05.6baac525.jpg";